import "./addAssetConditionForm.scss";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import newRequest from "../../../utils/newRequest";
import CustomSnakebar from "../../../utils/CustomSnakebar";
import { useTranslation } from "react-i18next";

const AddOtherAssetsCitiesForm = ({ inputs, title }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };

  const handleSubmit = async (event) => {
    if (!event.target.checkValidity()) return;
    event.preventDefault();
    try {
      setIsLoading(true);
      const data = {
        TblCountryID: 1,
        RegionCode: event.target.RegionCode.value,
        CityCode: event.target.CityCode.value,
        CityName: event.target.CityName.value,
      };
      await newRequest.post("/PostCity", data);
      setMessage(t("Successfully Added") || "Successfully Added");
    } catch (err) {
      setError(err?.response?.data?.message ?? "Failed to Add");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (event, inputName) => {
    setFormValues({ ...formValues, [inputName]: event.target.value });
  };

  return (
    <>
      {isLoading && (
        <div
          className="loading-spinner-background"
          style={{
            zIndex: 9999,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BeatLoader size={18} color="#6439ff" loading={isLoading} />
        </div>
      )}
      <span>
        {message && (
          <CustomSnakebar
            message={message}
            severity="success"
            onClose={resetSnakeBarMessages}
          />
        )}
        {error && (
          <CustomSnakebar
            message={error}
            severity="error"
            onClose={resetSnakeBarMessages}
          />
        )}
        <div className="assetCategoryForm">
          <div className="newContainer">
            <div className="top">
              <span className="topSpan">
                <h1>{title}</h1>
                <button type="button" onClick={() => navigate(-1)}>
                  {t("Go Back")}
                </button>
              </span>
            </div>
            <div className="bottom">
              <div className="right">
                <form onSubmit={handleSubmit} id="otherAssetsCitiesForm">
                  {inputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label htmlFor={input.name}>{input.label}</label>
                      <input
                        type={input.type || "text"}
                        placeholder={input.placeholder}
                        name={input.name}
                        id={input.name}
                        required={input.isFieldRequired}
                        value={formValues[input.name] ?? ""}
                        onChange={(e) => handleInputChange(e, input.name)}
                      />
                    </div>
                  ))}
                  <div className="buttonAdd">
                    <button type="submit">{t("Add")} {t("City")}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </span>
    </>
  );
};

export default AddOtherAssetsCitiesForm;
